import { render, staticRenderFns } from "./ReportError.vue?vue&type=template&id=fc1fb416&scoped=true"
import script from "./ReportError.vue?vue&type=script&lang=js"
export * from "./ReportError.vue?vue&type=script&lang=js"
import style0 from "./ReportError.vue?vue&type=style&index=0&id=fc1fb416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1fb416",
  null
  
)

export default component.exports